import React from "react";
import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import person1 from "../../Assets/Images/person1.png";
import person2 from "../../Assets/Images/person2.png";
import person3 from "../../Assets/Images/person3.png";

import person4 from "../../Assets/Images/person4.png";
import { FaArrowRight } from "react-icons/fa6";

const ServiceBanner = () => {
  return (
    <div className="container-fluid service-banner">
      <div className="service-banner-content ">
        <h2>
          Your Complete Partner in International <br /> Certification & Compliance
        </h2>
        <p>
          We offer ISO certification, training, and inspections — making
          compliance simple, efficient, and valuable for your business.
        </p>

        <button className="btn btn-outline-light rounded-pill px-4 mt-3">
          Get started
        </button>
      </div>
    </div>
  );
};

export default ServiceBanner;
